module.exports = __webpack_public_path__ + "img/ring-lvl3.b7f18768.jpg";